<div class="gpd-scroll gpd-full-page2">
  <!-- ── Hero ─────────────────────────────────────────────────── -->
  <div class="overview-hero straight-top-border-raidus" [class.hero-no-image]="!hasCustomImage">
    <img
      class="hero-bg-image"
      [src]="hasCustomImage ? (projectId | projectImage: projectImageVersion | async) : 'assets/images/elements/property-no-image.jpg'"
    />
    <div class="hero-gradient"></div>

    <div class="hero-controls">
      <button class="hero-ctrl-btn hero-ctrl-btn--favorite" (click)="toggleProjectFavorite()">
        <app-svg-icon
          icon="favorite"
          [size]="24"
          [strokeWidth]="1.5"
          [color]="isFavorite ? 'var(--color-primary, #629d37)' : 'white'"
          [fill]="fillColor"
        ></app-svg-icon>
      </button>
      <button class="hero-ctrl-btn" (click)="openImageLightbox()">
        <app-svg-icon icon="arrow-expand" [size]="24" [strokeWidth]="1.5" color="white"></app-svg-icon>
      </button>
      <label *ngIf="!hasCustomImage" class="hero-ctrl-btn">
        <input
          class="hidden-file-input"
          accept="image/*"
          type="file"
          (change)="uploadProjectImage($event.target['files'][0])"
        />
        <app-svg-icon icon="upload-cloud-2" [size]="24" [strokeWidth]="1.5" color="white"></app-svg-icon>
      </label>
      <button *ngIf="hasCustomImage" class="hero-ctrl-btn" (click)="deleteProjectImage()">
        <app-svg-icon icon="delete" [size]="24" [strokeWidth]="1.5" color="white"></app-svg-icon>
      </button>
    </div>

    <!-- ── Image Lightbox ─────────────────────────────────────── -->
    <div class="lightbox-overlay" *ngIf="imageLightboxVisible" (click)="onLightboxOverlayClick($event)">
      <div class="lightbox-container">
        <div class="lightbox-toolbar">
          <div class="lightbox-zoom-controls">
            <button class="lightbox-btn" (click)="zoomOut()" [disabled]="imageZoom <= 0.5" title="Zoom out">
              <app-svg-icon icon="search-minus" [size]="20" [strokeWidth]="1.5" color="white"></app-svg-icon>
            </button>
            <span class="lightbox-zoom-label">{{ imageZoomPercent }}%</span>
            <button class="lightbox-btn" (click)="zoomIn()" [disabled]="imageZoom >= 4" title="Zoom in">
              <app-svg-icon icon="search-add" [size]="20" [strokeWidth]="1.5" color="white"></app-svg-icon>
            </button>
          </div>
          <button class="lightbox-btn lightbox-btn--close" (click)="closeImageLightbox()" title="Close">
            <app-svg-icon icon="cancel" [size]="22" [strokeWidth]="1.5" color="white"></app-svg-icon>
          </button>
        </div>
        <div class="lightbox-image-area" (wheel)="onLightboxWheel($event)">
          <img
            class="lightbox-image"
            [src]="hasCustomImage ? (projectId | projectImage: projectImageVersion | async) : 'assets/images/elements/property-no-image.jpg'"
            [style.transform]="'scale(' + imageZoom + ')'"
            alt="Project image"
          />
        </div>
      </div>
    </div>

    <div class="hero-content">
      <div class="hero-badges">
        <span *ngIf="projectHeaddata?.status" class="status-badge status-{{ statusClass }}">
          {{ projectHeaddata.status }}
        </span>
      </div>
      <div class="hero-title">{{ projectHeaddata?.pva }}</div>
    </div>
  </div>

  <!-- ── KPI row ────────────────────────────────────────────────── -->
  <!-- Plant Size / Specific Yield moved into the "Allgemein" section below. -->
  <div class="kpi-row">
    <app-kpi-card
      *ngIf="overview?.installerOrDeveloper"
      [label]="overview.installerOrDeveloper"
      [value]="overview.installerOrDeveloperValue"
      icon="user-multiple"
      color="blue"
      [smallValue]="true"
    >
    </app-kpi-card>
  </div>

  <!-- ── General + Progress row ───────────────────────────────── -->
  <div class="two-col-row">
    <!-- ── Identity + Data (stacked) ────────────────────────────── -->
    <div class="one-third-column">
    <!-- ── Identity ──────────────────────────────────────────────── -->
    <div class="section-group section-group--one-third" *ngIf="projectHeaddata">
      <div class="section-group-header">
        <span class="section-group-title" i18n="@@general">General</span>
        <div class="section-group-actions">
          <app-gpd-button
            *ngIf="!editModeGeneral"
            type="text"
            i18n-text="@@edit"
            text="Edit"
            icon="edit"
            (onClick)="enableEditModeGeneral()"
          >
          </app-gpd-button>
          <app-gpd-button
            *ngIf="editModeGeneral"
            i18n-text="@@save"
            text="Save"
            icon="check"
            [disabled]="saving"
            (onClick)="saveChanges()"
          >
          </app-gpd-button>
          <app-gpd-button
            *ngIf="editModeGeneral"
            type="secondary"
            i18n-text="@@cancel"
            text="Cancel"
            icon="cancel"
            [disabled]="saving"
            (onClick)="disableEditModeGeneral()"
          >
          </app-gpd-button>
        </div>
      </div>
      <!-- Read-only view -->
      <div *ngIf="!editModeGeneral" class="dotted-row-list">
        <div class="dotted-row">
          <span class="dotted-row-label" i18n="@@projectNr">Project Number</span>
          <span class="dotted-row-rule"></span>
          <span class="dotted-row-value" *ngIf="projectHeaddata.nr; else ph1">{{ projectHeaddata.nr }}</span>
          <ng-template #ph1
            ><span class="dotted-row-value dotted-row-placeholder">{{ placeholderNotYetAssigned }}</span></ng-template
          >
        </div>
        <div class="dotted-row">
          <span class="dotted-row-label" i18n="@@pvaCaps">Project Name</span>
          <span class="dotted-row-rule"></span>
          <span class="dotted-row-value" *ngIf="projectHeaddata.pva; else ph2">{{ projectHeaddata.pva }}</span>
          <ng-template #ph2
            ><span class="dotted-row-value dotted-row-placeholder">{{ placeholderNoTitleSet }}</span></ng-template
          >
        </div>
        <div class="dotted-row">
          <span class="dotted-row-label" i18n="@@status">Status</span>
          <span class="dotted-row-rule"></span>
          <span class="dotted-row-value" *ngIf="projectHeaddata.status; else ph3">{{ projectHeaddata.status }}</span>
          <ng-template #ph3
            ><span class="dotted-row-value dotted-row-placeholder">{{ placeholderNoneSelected }}</span></ng-template
          >
        </div>
        <div class="dotted-row" *ngIf="showStatusDate">
          <span class="dotted-row-label" i18n="@@statusDate">Status Date</span>
          <span class="dotted-row-rule"></span>
          <span class="dotted-row-value" *ngIf="projectHeaddata.statusDate; else phStatusDate">{{
            projectHeaddata.statusDate | date: 'dd.MM.yyyy'
          }}</span>
          <ng-template #phStatusDate
            ><span class="dotted-row-value dotted-row-placeholder">{{ placeholderNoneSelected }}</span></ng-template
          >
        </div>
        <div class="dotted-row" *ngIf="showReason">
          <span class="dotted-row-label" i18n="@@reason">Reason</span>
          <span class="dotted-row-rule"></span>
          <span class="dotted-row-value" *ngIf="projectHeaddata.statusReason; else phReason">{{
            projectHeaddata.statusReason
          }}</span>
          <ng-template #phReason
            ><span class="dotted-row-value dotted-row-placeholder">{{ placeholderNoneSelected }}</span></ng-template
          >
        </div>
        <div class="dotted-row">
          <span class="dotted-row-label" i18n="@@classification">Classification</span>
          <span class="dotted-row-rule"></span>
          <span class="dotted-row-value" *ngIf="areaTypeName; else ph4">{{ areaTypeName }}</span>
          <ng-template #ph4
            ><span class="dotted-row-value dotted-row-placeholder">{{ placeholderUnclassified }}</span></ng-template
          >
        </div>
        <div class="dotted-row">
          <span class="dotted-row-label" i18n="@@remunerationType">Remuneration Type</span>
          <span class="dotted-row-rule"></span>
          <span class="dotted-row-value" [title]="remunerationTypeNames" *ngIf="remunerationTypeNames; else ph5">{{
            remunerationTypeNames
          }}</span>
          <ng-template #ph5
            ><span class="dotted-row-value dotted-row-placeholder">{{ placeholderNoneSelected }}</span></ng-template
          >
        </div>
        <div class="dotted-row">
          <span class="dotted-row-label" i18n="@@plantSize">Plant size</span>
          <span class="dotted-row-rule"></span>
          <span class="dotted-row-value" *ngIf="overview?.plantSize; else ph6">{{ overview.plantSize }} {{ overview.plantSizeUnit ?? '' }}</span>
          <ng-template #ph6
            ><span class="dotted-row-value dotted-row-placeholder">{{ placeholderNoneSelected }}</span></ng-template
          >
        </div>
      </div>

      <!-- Edit view -->
      <dx-form
        #editFormGeneral
        *ngIf="editModeGeneral"
        [(formData)]="projectHeaddata"
        [colCount]="1"
        [showColonAfterLabel]="false"
        labelLocation="top"
      >
        <dxi-item
          dataField="nr"
          editorType="dxNumberBox"
          cssClass="required-field"
          [editorOptions]="{ min: 1, max: 9999999999999999, placeholder: placeholderNotYetAssigned }"
        >
          <dxo-label i18n-text="@@projectNr" text="Project Number"></dxo-label>
          <dxi-validation-rule type="required" [message]="projectNumberRequiredMsg"></dxi-validation-rule>
        </dxi-item>
        <dxi-item
          dataField="pva"
          cssClass="required-field"
          [editorOptions]="{ maxLength: 255, placeholder: placeholderNoTitleSet }"
        >
          <dxo-label i18n-text="@@pvaCaps" text="Project Name"></dxo-label>
          <dxi-validation-rule type="required" [message]="projectNameRequiredMsg"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="status" editorType="dxSelectBox" [editorOptions]="statusEditorOptions">
          <dxo-label i18n-text="@@status" text="Status"></dxo-label>
        </dxi-item>
        <dxi-item
          dataField="statusDate"
          editorType="dxDateBox"
          [visible]="showStatusDate"
          [cssClass]="showStatusDate && !isStatusDateReadOnly ? 'required-field' : ''"
          [editorOptions]="statusDateEditorOptions"
        >
          <dxo-label i18n-text="@@statusDate" text="Status Date"></dxo-label>
          <dxi-validation-rule
            *ngIf="showStatusDate && !isStatusDateReadOnly"
            type="required"
            [message]="statusDateRequiredMsg"
          ></dxi-validation-rule>
        </dxi-item>
        <dxi-item
          dataField="statusReason"
          editorType="dxTextBox"
          [visible]="showReason"
          [cssClass]="showReason ? 'required-field' : ''"
          [editorOptions]="reasonEditorOptions"
        >
          <dxo-label i18n-text="@@reason" text="Reason"></dxo-label>
          <dxi-validation-rule *ngIf="showReason" type="required" [message]="reasonRequiredMsg"></dxi-validation-rule>
        </dxi-item>
        <dxi-item
          dataField="areaTypeId"
          editorType="dxSelectBox"
          [editorOptions]="{
            readOnly: true,
            dataSource: areaTypeEditOptions,
            displayExpr: 'name',
            valueExpr: 'id',
            placeholder: placeholderUnclassified,
          }"
        >
          <dxo-label i18n-text="@@classification" text="Classification"></dxo-label>
        </dxi-item>
        <dxi-item dataField="remunerationTypes">
          <dxo-label i18n-text="@@remunerationType" text="Remuneration Type"></dxo-label>
          <div *dxTemplate>
            <dx-tag-box
              [items]="remunerationTypes"
              displayExpr="title"
              [showSelectionControls]="true"
              valueExpr="id"
              applyValueMode="useButtons"
              [(value)]="projectHeaddata.remunerationTypes"
              [placeholder]="placeholderNoneSelected"
            >
            </dx-tag-box>
          </div>
        </dxi-item>
      </dx-form>
    </div>

    <!-- ── Task Results (Aufgabenergebnisse) ────────────────────── -->
    <div class="section-group section-group--one-third" *ngIf="projectHeaddata">
      <div class="section-group-header">
        <span class="section-group-title" i18n="@@taskResults">Task Results</span>
      </div>
      <!-- Every tag present in the results is a toggle: click to filter, click again to undo. -->
      <div class="task-tag-toggles" *ngIf="taskTagOptions.length" role="group" i18n-aria-label="@@filterByTag" aria-label="Filter by tag">
        <gpd-pill
          i18n-text="@@all"
          text="All"
          [clickable]="true"
          class="gpd-toggle-pill"
          [class.is-selected]="!selectedTaskTagIds.length"
          [backgroundColor]="!selectedTaskTagIds.length ? 'var(--color-primary)' : 'transparent'"
          [color]="!selectedTaskTagIds.length ? 'var(--color-white)' : 'var(--color-primary)'"
          [attr.aria-pressed]="!selectedTaskTagIds.length"
          (onClick)="setTaskTagFilter([])"
        ></gpd-pill>
        <gpd-pill
          *ngFor="let tag of taskTagOptions"
          [text]="tag.name"
          [clickable]="true"
          [backgroundColor]="isTaskTagSelected(tag.id) ? 'var(--color-primary)' : 'transparent'"
          [color]="isTaskTagSelected(tag.id) ? 'var(--color-white)' : 'var(--color-primary)'"
          class="gpd-toggle-pill"
          [class.is-selected]="isTaskTagSelected(tag.id)"
          [attr.aria-pressed]="isTaskTagSelected(tag.id)"
          (onClick)="toggleTaskTag(tag.id)"
        ></gpd-pill>
      </div>
      <p class="task-results-filter-note" *ngIf="selectedTaskTagIds.length" i18n="@@taskResultsFilteredCount">
        {{ filteredTaskResults.length }} of {{ overviewTaskResults.length }} task results
      </p>
      <div class="dotted-row-list" *ngIf="overviewTaskResults?.length; else noTaskResults">
        <div class="section-empty-state" *ngIf="!filteredTaskResults.length">
          <span class="section-empty-state-text" i18n="@@noTaskResultsForTags">No task results match the selected tags.</span>
        </div>
        <div class="dotted-row" *ngFor="let item of filteredTaskResults">
          <span class="dotted-row-label">{{ item.label }}</span>
          <span class="dotted-row-rule"></span>

          <!-- "contact"/"contract"/"document" results render as the same pill used by the
               Contract Deadlines section below, instead of raw text/ids. -->
          <ng-container *ngIf="item.isPill; else plainResult">
            <app-contracts-pill
              *ngIf="item.pillContent; else phData"
              class="dotted-row-pill"
              [content]="item.pillContent"
              [linkType]="item.type"
            ></app-contracts-pill>
          </ng-container>

          <ng-template #plainResult>
            <span class="dotted-row-value" [title]="item.displayText" *ngIf="item.displayText; else phData">{{
              item.displayText
            }}</span>
          </ng-template>

          <ng-template #phData
            ><span class="dotted-row-value dotted-row-placeholder" i18n="@@noResultYet"
              >No result yet</span
            ></ng-template
          >
        </div>
      </div>
      <ng-template #noTaskResults>
        <div class="section-empty-state">
          <app-svg-icon icon="tasks" [size]="28" [strokeWidth]="1.5" color="#bbb"></app-svg-icon>
          <span class="section-empty-state-text" i18n="@@noTaskResultsConfigured"
            >No tasks have been selected for this section yet.</span
          >
        </div>
      </ng-template>
    </div>

    <!-- ── Contract Deadlines ────────────────────────────────────── -->
    <div class="section-group section-group--one-third" *ngIf="projectHeaddata && contractsEnabled">
      <div class="section-group-header">
        <span class="section-group-title" i18n="@@contractDeadlines">Contract Deadlines</span>
      </div>
      <div class="deadline-list" *ngIf="overviewDeadlines?.length; else noDeadlines">
        <div class="deadline-row" *ngFor="let deadline of overviewDeadlines">
          <app-contracts-pill class="deadline-pill" [content]="deadline" [linkType]="'contract'"></app-contracts-pill>
          <span class="deadline-type">{{ deadline.typeLabel }}</span>
          <span class="dotted-row-rule"></span>
          <app-status-pill [statusId]="deadline.statusId" [statusConfig]="taskStatusConfig"></app-status-pill>
          <span class="deadline-date">{{ deadline.date | date: 'dd.MM.yyyy' }}</span>
        </div>
      </div>
      <ng-template #noDeadlines>
        <div class="section-empty-state">
          <app-svg-icon icon="calendar" [size]="28" [strokeWidth]="1.5" color="#bbb"></app-svg-icon>
          <span class="section-empty-state-text" i18n="@@noContractDeadlinesConfigured"
            >No contract deadlines have been opted in for this project's overview yet.</span
          >
        </div>
      </ng-template>
    </div>
    </div>

    <!-- ── Milestone Status + Team (same main-content column, per Figma) ── -->
    <div class="main-content-column">
    <div class="section-group" *ngIf="milestonePhaseGroups?.length">
      <div class="section-group-header">
        <span class="section-group-title" i18n="@@projectStatus">Project Status</span>
      </div>
      <div class="milestone-accordion">
        <div *ngFor="let group of milestonePhaseGroups" class="accordion-group">
          <!-- Phase card -->
          <div class="accordion-phase-card">
            <!-- Phase header -->
            <div class="accordion-phase-header" (click)="togglePhase(group.phaseName)">
              <app-svg-icon
                icon="chevron-down"
                [size]="16"
                [strokeWidth]="2.5"
                color="#555"
                [class.chevron-open]="isPhaseExpanded(group.phaseName)"
                class="accordion-chevron"
              >
              </app-svg-icon>
              <span class="accordion-phase-label">{{ group.phaseName }}</span>
              <app-status-pill
                *ngIf="getPhaseStatusId(group) !== null"
                [statusId]="getPhaseStatusId(group)"
                [statusConfig]="taskStatusConfig"
              ></app-status-pill>
              <span class="accordion-phase-spacer"></span>
              <div class="accordion-phase-progress" *ngIf="getPhaseCompletion(group) !== null">
                <div class="accordion-progress-meta">
                  <span class="accordion-progress-label" i18n="@@progress">Progress</span>
                  <span class="accordion-progress-pct">{{ getPhaseCompletion(group) }}%</span>
                </div>
                <div class="accordion-progress-track">
                  <div class="accordion-progress-fill" [style.width.%]="getPhaseCompletion(group)"></div>
                </div>
              </div>
            </div>

            <!-- Milestones inside the card -->
            <div *ngIf="isPhaseExpanded(group.phaseName)" class="accordion-phase-milestones">
              <div
                *ngFor="let ms of group.milestones"
                class="accordion-milestone"
                [class.accordion-milestone--overdue]="ms.scheduleStatusId === 7"
                [class.accordion-milestone--at-risk]="ms.scheduleStatusId === 8"
                [class.accordion-milestone--done]="ms.scheduleStatusId === 4"
              >
                <div
                  class="accordion-milestone-row"
                  [class.accordion-milestone-row--clickable]="milestoneHasTasks(ms.name)"
                  (click)="milestoneHasTasks(ms.name) && toggleMilestone(ms.name)"
                >
                  <app-svg-icon
                    icon="chevron-down"
                    [size]="14"
                    [strokeWidth]="2"
                    [color]="
                      milestoneHasTasks(ms.name) ? 'var(--color-text-secondary, #666)' : 'var(--gt-border-color, #ccc)'
                    "
                    [class.chevron-open]="isMilestoneExpanded(ms.name)"
                    class="accordion-chevron"
                  >
                  </app-svg-icon>
                  <div class="accordion-milestone-left">
                    <div class="accordion-milestone-info">
                      <span class="accordion-milestone-name">{{ ms.name }}</span>
                      <span *ngIf="ms.endDate" class="accordion-milestone-duedate"
                        >{{ ms.scheduleStatusId === 4 ? 'Erledigt am' : 'Fällig' }}:
                        {{ ms.endDate | date: 'd.M.yyyy' }}</span
                      >
                    </div>
                    <div class="accordion-milestone-status">
                      <app-status-pill
                        *ngIf="milestoneHasTasks(ms.name) || ms.completionPercentage === 100"
                        [statusId]="getMilestoneStatusId(ms)"
                        [statusConfig]="taskStatusConfig"
                      >
                      </app-status-pill>
                    </div>
                  </div>
                  <span class="accordion-phase-spacer"></span>
                  <div class="accordion-milestone-progress">
                    <span class="accordion-progress-pct">{{ ms.completionPercentage }}%</span>
                    <div class="accordion-progress-track">
                      <div class="accordion-progress-fill" [style.width.%]="ms.completionPercentage"></div>
                    </div>
                  </div>
                </div>

                <!-- Packages -->
                <div *ngIf="isMilestoneExpanded(ms.name)" class="accordion-packages">
                  <ng-container *ngIf="milestonePackageMap[ms.name]?.length; else noPackages">
                    <a
                      *ngFor="let pkg of milestonePackageMap[ms.name]"
                      class="accordion-package-row"
                      [class.accordion-package-row--link]="pkg.statusId !== null"
                      [attr.href]="pkg.statusId !== null ? getPackageUrl(pkg.id) : null"
                      (click)="onPackageRowClick($event, pkg)"
                    >
                      <div class="accordion-package-left">
                        <span
                          class="accordion-package-name"
                          [class.accordion-package-name--link]="pkg.statusId !== null"
                        >
                          {{ pkg.name }}
                        </span>

                        <app-status-pill
                          *ngIf="pkg.statusId !== null"
                          [statusId]="pkg.statusId"
                          [statusConfig]="taskStatusConfig"
                        >
                        </app-status-pill>
                      </div>

                      <!-- Progress -->
                      <div class="accordion-package-progress">
                        <span class="accordion-progress-pct"> {{ pkg.completionPercentage || 0 }}% </span>

                        <div class="accordion-progress-track">
                          <div class="accordion-progress-fill" [style.width.%]="pkg.completionPercentage || 0"></div>
                        </div>
                      </div>
                    </a>
                  </ng-container>

                  <ng-template #noPackages>
                    <span class="field-placeholder-text accordion-empty" i18n="@@noTaskPackages">
                      No task packages
                    </span>
                  </ng-template>
                </div>
              </div>
            </div>
            <!-- /.isPhaseExpanded -->
          </div>
          <!-- /.accordion-phase-card -->
        </div>
      </div>
    </div>

    <!-- ── Team ──────────────────────────────────────────────────── -->
    <div class="section-group" *ngIf="projectHeaddata">
    <div class="section-group-header">
      <span class="section-group-title" i18n="@@team">Team</span>
      <div class="section-group-actions">
        <app-gpd-button
          *ngIf="!editModeTeam"
          type="text"
          i18n-text="@@edit"
          text="Edit"
          icon="edit"
          (onClick)="enableEditModeTeam()"
        >
        </app-gpd-button>
        <app-gpd-button
          *ngIf="editModeTeam"
          i18n-text="@@save"
          text="Save"
          icon="check"
          [disabled]="saving"
          (onClick)="saveChanges()"
        >
        </app-gpd-button>
        <app-gpd-button
          *ngIf="editModeTeam"
          type="secondary"
          i18n-text="@@cancel"
          text="Cancel"
          icon="cancel"
          [disabled]="saving"
          (onClick)="disableEditModeTeam()"
        >
        </app-gpd-button>
      </div>
    </div>
    <!-- Read-only view -->
    <div *ngIf="!editModeTeam" class="dotted-row-list">
      <div class="dotted-row">
        <span class="dotted-row-label" i18n="@@partner">Partner</span>
        <span class="dotted-row-rule"></span>
        <span
          class="dotted-row-value"
          [title]="name"
          *ngIf="projectHeaddata.partnerName as name; else noPartner"
          >{{ name }}</span
        >
        <ng-template #noPartner
          ><span class="dotted-row-value dotted-row-placeholder">{{ placeholderNoneSelected }}</span></ng-template
        >
      </div>
      <div class="dotted-row">
        <span class="dotted-row-label" i18n="@@epc">EPC</span>
        <span class="dotted-row-rule"></span>
        <span
          class="dotted-row-value"
          [title]="name"
          *ngIf="projectHeaddata.epcName as name; else noEpc"
          >{{ name }}</span
        >
        <ng-template #noEpc
          ><span class="dotted-row-value dotted-row-placeholder">{{ placeholderNoneSelected }}</span></ng-template
        >
      </div>
      <div class="dotted-row" *ngFor="let department of projectHeaddata.departments; trackBy: trackByDepartmentName">
        <span class="dotted-row-label">{{ department.departmentName }}</span>
        <span class="dotted-row-rule"></span>
        <!-- #4994: a whole department holds the role -->
        <div class="dotted-row-value dotted-row-user" *ngIf="department.assignedDepartmentId != null; else personHolder">
          <app-svg-icon icon="user-multiple" [size]="20" color="var(--color-primary)"></app-svg-icon>
          <span class="user-name">{{ department.assignedDepartmentName }}</span>
        </div>
        <ng-template #personHolder>
          <div class="dotted-row-value dotted-row-user" *ngIf="getUserByMail(department.userMail) as user; else noUser">
            <app-user-avatar [userEmail]="department.userMail" [size]="20"></app-user-avatar>
            <span class="user-name">{{ user.displayName }}</span>
          </div>
        </ng-template>
        <ng-template #noUser
          ><span class="dotted-row-value dotted-row-placeholder">{{ placeholderNoneSelected }}</span></ng-template
        >
      </div>
    </div>

    <!-- Edit view -->
    <dx-form
      *ngIf="editModeTeam"
      [(formData)]="projectHeaddata"
      [colCount]="1"
      [showColonAfterLabel]="false"
      labelLocation="top"
    >
      <dxi-item dataField="partner" [colSpan]="1">
        <dxo-label i18n-text="@@partner" text="Partner"></dxo-label>
        <div *dxTemplate>
          <div class="contacts-dropdown-box-container">
            <app-contacts-dropdown-box
              [(contactId)]="projectHeaddata.partnerId"
              [contactType]="projectHeaddata.partnerType"
              [companies]="companies"
              [persons]="persons"
              [placeholder]="placeholderAssignContact"
              (onContactSelected)="onDropdownContactSelected($event, 'partnerId', 'partnerType')"
            >
            </app-contacts-dropdown-box>
            <dx-button
              icon="overflow"
              (onClick)="showContactsPopup(); setPopupReturnTarget('partnerId', 'partnerType')"
            >
            </dx-button>
          </div>
        </div>
      </dxi-item>
      <dxi-item dataField="epc" [colSpan]="1">
        <dxo-label i18n-text="@@epc" text="EPC"></dxo-label>
        <div *dxTemplate>
          <div class="contacts-dropdown-box-container">
            <app-contacts-dropdown-box
              [contactId]="projectHeaddata.epcId"
              [contactType]="projectHeaddata.epcType"
              [companies]="companies"
              [persons]="persons"
              [placeholder]="placeholderAssignContact"
              (onContactSelected)="onDropdownContactSelected($event, 'epcId', 'epcType')"
            >
            </app-contacts-dropdown-box>
            <dx-button icon="overflow" (onClick)="showContactsPopup(); setPopupReturnTarget('epcId', 'epcType')">
            </dx-button>
          </div>
        </div>
      </dxi-item>
      <dxi-item *ngFor="let department of projectHeaddata.departments; trackBy: trackByDepartmentName" [colSpan]="1">
        <dxo-label [text]="department.departmentName"></dxo-label>
        <div *dxTemplate="">
          <app-holder-select
            [users]="users"
            [departments]="departments"
            [(email)]="department.userMail"
            [(departmentId)]="department.assignedDepartmentId"
          ></app-holder-select>
        </div>
      </dxi-item>
    </dx-form>
  </div>
  </div>
  </div>
</div>

<!-- ── Popups ─────────────────────────────────────────────────── -->
<app-contacts-popup
  [(visible)]="contactsPopupVisible"
  (onHiding)="contactsPopupVisible = false"
  [(companies)]="companies"
  [(persons)]="persons"
  (onContactSelected)="onPopupContactSelected($event, field, fieldType)"
  (onContactAdded)="onNewContactSelected($event, field, fieldType)"
  width="100px"
  height="auto"
>
</app-contacts-popup>

<app-delete-popup
  i18n-message
  message="Delete project?"
  [(visible)]="deletePopupVisible"
  (onConfirm)="deleteProject($event)"
  (onAbort)="abortDelete($event)"
>
</app-delete-popup>

<dx-popup
  [title]="outstandingCostsPopupTitle"
  [(visible)]="outstandingCostsPopupVisible"
  [width]="480"
  height="auto"
  [showCloseButton]="false"
  [hideOnOutsideClick]="false"
  [dragEnabled]="true"
>
  <p i18n="@@outstandingCostsWarningText">
    There are still outstanding costs in the project. If you change the status, these costs will no longer be displayed in reports or evaluations.
  </p>
  <div class="gt-bottom-page-button-container">
    <div class="gt-flex-width">
      <app-gpd-button
        type="secondary"
        i18n-text="@@cancel"
        text="Cancel"
        icon="cancel"
        (onClick)="cancelOutstandingCosts()"
      ></app-gpd-button>
    </div>
    <div class="gt-flex-dir-row-rev">
      <app-gpd-button
        i18n-text="@@confirm"
        text="Confirm"
        icon="check"
        (onClick)="confirmOutstandingCosts()"
      ></app-gpd-button>
    </div>
  </div>
</dx-popup>

<dx-toast [(visible)]="toastVisible" i18n-message message="Successfully saved"></dx-toast>
<dx-toast [(visible)]="favoriteToastVisible" [message]="favoriteMessage" [type]="favoriteToastType"></dx-toast>


<app-project-complete-popup
  [(visible)]="projectCompletePopupVisible"
  [userName]="currentUserName"
></app-project-complete-popup>
